export default __webpack_public_path__ + "static/media/c1na.4be0530b.jpg";